import { ProjectIssueAttachment } from '../model/entities';
import providerAuthService from '../services/ProviderAuthService';
import { proxyApiAxios } from './CustomAxios';

class ProjectIssueAttachmentApi {
    list = async (hubId: string, projectId: string, issueId: string): Promise<ProjectIssueAttachment[]> => {
        const headers = await providerAuthService.getRequestHeader('ACC');
        const response = await proxyApiAxios.get<ProjectIssueAttachment[]>('/project-issue-attachments', {
            params: { hubId, projectId, issueId },
            headers,
        });

        return response.data;
    };
}

const projectIssueAttachmentApi: ProjectIssueAttachmentApi = new ProjectIssueAttachmentApi();
export default projectIssueAttachmentApi;
